import { SpecialClassNames, SpecialClassValues } from '@shared/models/rating';
import {
  WhatIfRequests,
  WhatIfRequestsAgrements,
  whatIfRequestsStatus,
  whatIfRequestsStatusKey,
} from '@shared/models/what-if-requests';
import { CustomerMatch, MatchCustomerByMadCodeResp, MatchCustomerResp } from '@xpo-ltl-2.0/sdk-customer';
import {
  CreateWhatIfRatingResp,
  CreateWhatIfRatingRqst,
  DeleteWhatIfRatingsResp,
  DownloadShipmentTemplateResp,
  WhatIfRatingRequest,
} from '@xpo-ltl-2.0/sdk-rating';
import { AuditInfo, CustomerTypeCd, WhatIfShipmentSelectionTypeCd } from '@xpo-ltl/sdk-common';
import { Agreement } from '@xpo-ltl/sdk-pricingagmtmgmt';

export const auditInfoMock: AuditInfo[] = [
  {
    createdById: 'userId',
    createdTimestamp: undefined,
    updateById: 'userId',
    updatedTimestamp: undefined,
    createByPgmId: 'WhatIfRatingImpl',
    updateByPgmId: 'WhatIfRatingImpl',
    correlationId: undefined,
    createdApplicationId: undefined,
    lastUpdateApplicationId: undefined,
  },
  {
    createdById: 'userId2',
    createdTimestamp: undefined,
    updateById: 'userId2',
    updatedTimestamp: undefined,
    createByPgmId: 'WhatIfRatingImpl',
    updateByPgmId: 'WhatIfRatingImpl',
    correlationId: undefined,
    createdApplicationId: undefined,
    lastUpdateApplicationId: undefined,
  },
];

export const whatIfRequestsMock: WhatIfRequests[] = [
  {
    ratingRequestId: 123456,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Submitted].key,
    requestedBy: 'John Doe',
    requestDateTime: 1621141200000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP991000',
    customerName: 'ClientName',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: undefined,
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: 'CO-99',
    overrideAgreementCustomerId: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 345678,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.InProgress].key,
    requestedBy: 'John Doe',
    requestDateTime: 1621054800000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.CUSTOMER_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910002',
    customerName: 'ClientName2',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: undefined,
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: '92.5',
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 567890,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Completed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620968400000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.AGREEMENT_ID,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910003',
    customerName: 'ClientName3',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: true,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 987601,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Completed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620795600000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.ACCOUNT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910004',
    customerName: 'ClientName4',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: '987456',
    overrideDestinationZipCd: '987456',
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 998761,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Completed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620795600000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910005',
    customerName: 'ClientName5',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 998762,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Failed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620795600000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910006',
    customerName: 'ClientName6',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 998763,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Completed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620795600000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.ACCOUNT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910007',
    customerName: 'ClientName7',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 998764,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Failed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620834030000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910008',
    customerName: 'ClientName8',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 998765,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Submitted].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620795600000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.AGREEMENT_ID,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910009',
    customerName: 'ClientName9',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
  {
    ratingRequestId: 998766,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Completed].key,
    requestedBy: 'John Doe',
    requestDateTime: 1620832830000,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP99100010',
    customerName: 'ClientName10',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: 'CIO',
    agreementVersionNbr: '04',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    agreementIdOverride: '123456789-KKO-01',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    agreementId: '12345683-CIO-04',
  },
];

export const whatIfRatingRequestsMock: WhatIfRatingRequest[] = [
  {
    ratingRequestId: 123456,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Submitted].key,
    requestedBy: 'John Doe',
    requestDateTime: undefined,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP991000',
    customerName: 'ClientName',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: '10',
    agreementVersionNbr: '004',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: 'CO-99',
    overrideAgreementCustomerId: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
  },
  {
    ratingRequestId: 345678,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.InProgress].key,
    requestedBy: 'John Doe',
    requestDateTime: undefined,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.CUSTOMER_SHIPMENT,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910002',
    customerName: 'ClientName2',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: '99',
    agreementVersionNbr: '004',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: '92.5',
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: undefined,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[1],
    comments: `Lorem Ipsum`,
  },
  {
    ratingRequestId: 567890,
    statusCd: whatIfRequestsStatus[whatIfRequestsStatusKey.Completed].key,
    requestedBy: 'John Doe',
    requestDateTime: undefined,
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.AGREEMENT_ID,
    shipmentFileName: 'my-file-name.csv',
    customerId: 12345683,
    customerMadCd: 'HODEP9910003',
    customerName: 'ClientName3',
    negotiatedCustomerId: 987654321,
    customerAgreementSuffixNbr: '99',
    agreementVersionNbr: '999',
    pickupStartDate: '01/01/2021',
    pickupEndDate: '01/06/2021',
    overrideRatingTariff: '',
    overridePickupDate: undefined,
    overrideOriginZipCd: undefined,
    overrideDestinationZipCd: undefined,
    overrideClassTypeCd: undefined,
    overrideNmfcItemCd: undefined,
    overrideAgreementCustomerId: undefined,
    overrideCustomerAgreementSuffixNbr: undefined,
    overrideAgreementVersionNbr: undefined,
    overridingAgreementCustomerMadCd: undefined,
    overridingAgreementCustomerName: undefined,
    overrideAmcAmount: undefined,
    useFscAtPickupInd: true,
    requestFileId: undefined,
    processStartDateTime: undefined,
    processEndDateTime: undefined,
    totalShipmentCount: undefined,
    processedShipmentCount: undefined,
    resultFileId: undefined,
    error: undefined,
    correlationId: undefined,
    auditInfo: auditInfoMock[0],
    comments: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
];

export const addWhatIfRequestsMock: CreateWhatIfRatingRqst[] = [
  {
    requestDateTime: new Date(),
    shipmentSelectionTypeCd: WhatIfShipmentSelectionTypeCd.XPO_SHIPMENT,
    shipmentFileData: ['f5ds4f65sdf4sd89f7sd89v74xc564v56sf4sd8f7sd89f7sd89f7sd9sdf79sdf7fd'],
    customerId: '123456',
    pricingAgreementId: '987654321',
    pricingAgreementInstId: 987654,
    pickupStartDate: '10-07-2021',
    pickupEndDate: '10-15-2021',
    comments: 'test comments',
    override: {
      overrideRatingTariff: '1000',
      overridePickupDate: '10-13-2021',
      useFscAtPickupInd: true,
      overrideOriginZipCd: '11520',
      overrideDestinationZipCd: 'J8N0B8',
      overrideClassTypeCd: '100',
      overrideNmfcItemCd: '500',
      overrideAgreementId: '125555',
      overrideAgreementInstId: 11166,
      overrideAmcAmount: 10.25,
    },
  },
];

export const whatIfRequestsCreatedMock: CreateWhatIfRatingResp[] = [
  {
    ratingRequestId: 12315464,
    errors: undefined,
  },
];

export const accountOptionsMock = [
  {
    name1: 'WAL-MART',
    name2: 'STORES INC',
    madCd: 'WLMRT991204',
    customerNbr: 303872541,
    customerTypeCd: CustomerTypeCd.CORPORATE,
    addressLine1: 'fake address WAL-MART',
    cityName: 'City WAL-MART',
    stateCd: 'CA',
    postalCd: '0054877',
  },
  {
    name1: 'CUSTOMER NAME 1',
    name2: 'CUSTOMER NAME 2',
    madCd: 'WLMRT991299',
    customerNbr: 303872555,
    customerTypeCd: CustomerTypeCd.BILL_TO,
    addressLine1: 'fake address CUSTOMER NAME 1',
    cityName: 'City CUSTOMER NAME 1',
    stateCd: 'KL',
    postalCd: '12345',
  },
  {
    name1: 'CUSTOMER NAME 3',
    name2: 'CUSTOMER NAME 4',
    madCd: 'WLMRT991200',
    customerNbr: 303872789,
    customerTypeCd: CustomerTypeCd.PICKUP_DELIVERY,
    addressLine1: 'fake address CUSTOMER NAME 3',
    cityName: 'City CUSTOMER NAME 3',
    stateCd: 'LA',
    postalCd: '65487',
  },
  {
    name1: 'CUSTOMER NAME 5',
    name2: 'CUSTOMER NAME 6',
    madCd: 'WLMRT991233',
    customerNbr: 303872777,
    customerTypeCd: CustomerTypeCd.SERVICE_RECIPIENT,
    addressLine1: 'fake address CUSTOMER NAME 5',
    cityName: 'City CUSTOMER NAME 5',
    stateCd: 'TX',
    postalCd: '98777',
  },
] as CustomerMatch[];

export const matchCustomerRespMock = [
  {
    matchedCustomers: accountOptionsMock as CustomerMatch[],
  },
] as MatchCustomerResp[];

export const matchCustomerByMadCodeRespMock = {
  customerMatch: accountOptionsMock as CustomerMatch[],
} as MatchCustomerByMadCodeResp;

export const agreementIdOptionsMock: WhatIfRequestsAgrements[] = [
  {
    id: 'WLMRT001900 - 62528121-03-001',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 123456,
  },
  {
    id: 'WLMRT001900 - 62528121-03-002',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 456789,
  },
  {
    id: 'WLMRT001900 - 62528121-03-003',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 65432,
  },
  {
    id: 'WLMRT001900 - 62528121-03-004',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 99874,
  },
  {
    id: 'WLMRT001900 - 62528121-03-005',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 12541,
  },
  {
    id: 'WLMRT001900 - 62528121-03-006',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 99658,
  },
  {
    id: 'WLMRT001901 - 62528121-03-007',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 33665,
  },
  {
    id: 'WLMRT001900 - 62528121-03-008',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 22114,
  },
  {
    id: 'WLMRT001900 - 62528121-03-009',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 22551,
  },
  {
    id: 'WLMRT001900 - 62528121-03-010',
    effective: '07/17/2020',
    expiry: '07/17/2021',
    reneg: ' 01/17/2021',
    agreementInstId: 3366885,
  },
];

export const agreementsMock: Agreement[] = [
  {
    agreementInstId: 4256457684435,
    typeCd: '1',
    effectiveDate: '2016-06-27',
    renegotiationDate: '2999-12-31',
    expirationDate: '2999-12-31',
    activeCd: 'Y',
    customerInstId: 18289487,
    secondaryCustomerId1: 811135394,
    secondaryCustomerId2: 0,
    extensionCount: 0,
    lastExtensionDate: '0001-01-01',
    accountExecutiveId: '55540',
    leadPaId: 'UM0570',
    secondaryPaId1: undefined,
    secondaryPaId2: undefined,
    customerAgreementSuffix: 1,
    agreementVersionNbr: 1,
    rulesetTypeCd: '1',
    agreementRestrictionCd: '0',
    externalFormatInd: false,
    liabilityAmount: 0,
    createdRequestInstId: 4256457237951,
    singleInstId: 4254546335858,
    customerTypeCd: undefined,
    signatureRequiredCd: undefined,
    priorAgreementNegotiatingCustomerId: 0,
    priorAgreementSuffixNbr: 0,
    priorAgreementVersionNbr: 0,
    revisionNbr: 1,
    serviceTypeCd: undefined,
    auditInfo: undefined,
  },
  {
    agreementInstId: 9999457684435,
    typeCd: '1',
    effectiveDate: '2016-06-27',
    renegotiationDate: '2999-12-31',
    expirationDate: '2999-12-31',
    activeCd: 'Y',
    customerInstId: 99989487,
    secondaryCustomerId1: 2221135394,
    secondaryCustomerId2: 0,
    extensionCount: 0,
    lastExtensionDate: '0001-01-01',
    accountExecutiveId: '55540',
    leadPaId: 'UM0570',
    secondaryPaId1: undefined,
    secondaryPaId2: undefined,
    customerAgreementSuffix: 9,
    agreementVersionNbr: 98,
    rulesetTypeCd: '1',
    agreementRestrictionCd: '0',
    externalFormatInd: false,
    liabilityAmount: 0,
    createdRequestInstId: 4256457237951,
    singleInstId: 4254546335858,
    customerTypeCd: undefined,
    signatureRequiredCd: undefined,
    priorAgreementNegotiatingCustomerId: 0,
    priorAgreementSuffixNbr: 0,
    priorAgreementVersionNbr: 0,
    revisionNbr: 1,
    serviceTypeCd: undefined,
    auditInfo: undefined,
  },
];

export const downloadShipmentTemplateRespMock: DownloadShipmentTemplateResp[] = [
  {
    shipmentTemplateFile:
      'UFJPIE5VTUJFUixQSUNLVVAgREFURQ0KMTAwMDI1LDc3ODU0NA0KOTg1NTQ3LGRmc2QNCjU1NTg4LGZzZGZzc2YNCjk5Nzc3OSw2NjY2DQpnZmhmZ2gsODk3ODc4DQp0cmV0cnJ0LGdoaGdoZmdoDQp0cnRydHJ0cnR3LDk5OTg3',
  },
];

export const deleteWhatIfRatingsRespMock: DeleteWhatIfRatingsResp[] = [{ errors: [] }];

export const classOptionsMock: string[] = [
  '',
  SpecialClassValues[SpecialClassNames._50],
  SpecialClassValues[SpecialClassNames._55],
  SpecialClassValues[SpecialClassNames._60],
  SpecialClassValues[SpecialClassNames._65],
  SpecialClassValues[SpecialClassNames._70],
  SpecialClassValues[SpecialClassNames._775],
  SpecialClassValues[SpecialClassNames._85],
  SpecialClassValues[SpecialClassNames._925],
  SpecialClassValues[SpecialClassNames._100],
  SpecialClassValues[SpecialClassNames._110],
  SpecialClassValues[SpecialClassNames._125],
  SpecialClassValues[SpecialClassNames._150],
  SpecialClassValues[SpecialClassNames._175],
  SpecialClassValues[SpecialClassNames._200],
  SpecialClassValues[SpecialClassNames._250],
  SpecialClassValues[SpecialClassNames._300],
  SpecialClassValues[SpecialClassNames._350],
  SpecialClassValues[SpecialClassNames._400],
  SpecialClassValues[SpecialClassNames._500],
];

export const whatIfRequestAgrementEmptyMock: WhatIfRequestsAgrements = {
  id: 'No Agreements',
  effective: undefined,
  expiry: undefined,
  agreementInstId: undefined,
};
